import axios from "axios";
// const env = window.env;

const baseURL = process.env.REACT_APP_SERVICE_URL;

export const authenticateService = {
  retrieve
};

function retrieve() {
  const requestConfig = {
    method: "GET",
    url: baseURL + "app/call/user"
  };

  return axios(requestConfig)
    .then((response) => handleResponse(response))
    .catch((error) => handleErrorResponse(error));
}

function handleResponse(response) {
  const data = response.data;

  if (data.length === 0) {
    return {};
  }

  return data;
}

function handleErrorResponse(error) {
  console.log(error); // eslint-disable-line
  return { error: "Error: Network Error" };
}
